import { LocalDate } from '@js-joda/core';

import { ConfidentialityLevel } from '@dreryk/egabinet-medical-data-confidentiality-published-language-api';

import { ChronicDiseaseEntryFormBean } from './chronicDiseaseEntryForm.types';

const isCurrentDoctor = (updatePersonalDataAvailable: boolean): boolean => {
   return updatePersonalDataAvailable;
};

export const chronicDiseaseEntryFormInitializer = (
   confidentialityLevel: ConfidentialityLevel
): ChronicDiseaseEntryFormBean => ({
   attachments: null,
   description: null,
   diagnosisCreationDate: LocalDate.now(),
   diagnosisRemovalDate: null,
   disease: null,
   diagnosedByCurrentPractitioner: false,
   diagnosedByName: null,
   diagnosedByLicenceNumber: null,
   removalDiagnosisByName: null,
   removalDiagnosisByLicenceNumber: null,
   removalReason: null,
   confidentialityLevel: confidentialityLevel,
});

export const forDoctor = (updatingDoctorPersonalDataAvailable: boolean): boolean => {
   return isCurrentDoctor(updatingDoctorPersonalDataAvailable);
};

export const forSpecialist = (updatingDoctorPersonalDataAvailable: boolean): boolean => {
   return !isCurrentDoctor(updatingDoctorPersonalDataAvailable);
};

export const removalSectionViewVisitor = (
   updatingDoctorPersonalDataAvailable: boolean,
   removalDate: LocalDate | null
) => <ACCEPT>(view: { forDoctor: () => ACCEPT; forSpecialist: () => ACCEPT }) => {
   if (!removalDate) return null;

   if (updatingDoctorPersonalDataAvailable) {
      return view.forDoctor();
   }

   return view.forSpecialist();
};
